// @flow
import * as React from 'react';
import Box from 'components/Box';

const { useState, useEffect, useRef } = React;

const FixedSpacerContainer = ({
  children,
  ...props
}: {
  children: React.Node
}) => {
  const ref = useRef(null);
  const [height, setHeight] = useState('auto');

  useEffect(
    () => {
      const update = () => {
        if (ref && ref.current) {
          setHeight(ref.current.offsetHeight || 'auto');
        }
      };
      update();

      if (window) {
        window.addEventListener('resize', update);
        return window.addEventListener('resize', update);
      }
    },
    [children]
  );

  return (
    <Box height={height}>
      <Box position="fixed" {...props}>
        <div ref={ref}>{children}</div>
      </Box>
    </Box>
  );
};

export default FixedSpacerContainer;
